import axios from "axios";
import { belladGroupWebsiteURL } from "../../utils/config";

export const saveContactUsInGoogleSheet = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.post(
        `${belladGroupWebsiteURL}/api/beltechWebsiteSaveContactUsForm`,
        data
      );
      if (response.status === 200) {
        resolve({ status: "SUCCESS" });
      } else {
        resolve({ status: "ERROR", error: response.data });
      }
    } catch (error) {
      resolve({ status: "ERROR", error: error });
    }
  });
};
